import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { addToCartText, hostingBillingTypeText } from '../../../api/global';
import { DISPLAY_LANG } from '../../../config';
import { CurrencyContext } from "../../../contexts/CurrencyContext";
import './HostingPlans.css';

export default function HostingPlans({ hostingPlansHeading, hostingPlans, billingType, setBillingType }) {
  const { selectedCurrency } = useContext(CurrencyContext);
  const navigate = useNavigate();

  const getHostingHandler = (plan) => {
    const isLogin = localStorage.getItem('token');
    sessionStorage.setItem('SELECTED_HOSTING_PLAN_NAME', plan.name);

    if (isLogin) {
      navigate(`/hosting/${plan.name}?billing=${billingType}`);
      sessionStorage.setItem('SELECTED_HOSTING_PLAN', JSON.stringify({ ...plan, billingType }));
    } else {
      navigate('/user/login');
    }
  };

  return (
    <div className="hosting-plans wrapper">
      <h2>{hostingPlansHeading.title}</h2>
      <p>{hostingPlansHeading.subtitle}</p>

      <div className="choose-paying-way flex-center">
        <span>{hostingPlansHeading.plan_billing_option.split('/')[0]}</span>

        <label className="switch">
          <input
            type="checkbox"
            checked={billingType === "yearly"}
            onChange={() => setBillingType(billingType === "monthly" ? "yearly" : "monthly")}
          />

          <span className="slider"></span>
        </label>

        <span>{hostingPlansHeading.plan_billing_option.split('/')[1]}</span>
      </div>

      <div className="plans flex-center">
        {
          hostingPlans.map((plan, idx) => {
            if (plan.name === 'Free') {
              return null;
            }

            return (
              <div key={idx} className={`plan ${plan.is_highlighted ? "active" : ""}`}>
                <div>
                  <h3>{plan.name}</h3>
                  <p className='plan-descr'>{plan.description[DISPLAY_LANG]}</p>

                  <div className="includes">
                    {
                      plan.characteristicslist.map((feature, i) => (
                        <p
                          key={i}
                          className={'flex-center'}
                        >
                          {
                            plan.is_highlighted ? (
                              <img src="/images/hosting_plans/check-white.svg" alt="check" />
                            ) : (
                              <img src="/images/hosting_plans/check-blue.svg" alt="check" />
                            )
                          }

                          {feature.title}
                        </p>
                      ))
                    }
                  </div>

                  <p className="price">
                    {
                      billingType === 'monthly' ? (
                        <>
                          {selectedCurrency.symbol === '$' && selectedCurrency.symbol + ' '}
                          {plan.prices.monthly[selectedCurrency.title]}
                          {selectedCurrency.symbol !== '$' && ' ' + selectedCurrency.symbol}
                          <span> / {hostingBillingTypeText[DISPLAY_LANG].split('/')[0]}</span>
                        </>
                      ) : (
                        <>
                          {selectedCurrency.symbol === '$' && selectedCurrency.symbol + ' '}
                          {Math.ceil(plan.prices.yearly[selectedCurrency.title] / 12).toFixed(2)}
                          {selectedCurrency.symbol !== '$' && ' ' + selectedCurrency.symbol}
                          <span> / {hostingBillingTypeText[DISPLAY_LANG].split('/')[0]}</span>

                          {/* yearli price poqr nerqevum */}
                          <div style={{ fontSize: '12px', color: '#999', marginTop: '10px' }}>
                            {selectedCurrency.symbol === '$' && selectedCurrency.symbol + ' '}
                            {plan.prices.yearly[selectedCurrency.title] + ' '}

                            <span style={{ fontSize: '12px' }}>
                              / {hostingBillingTypeText[DISPLAY_LANG].split('/')[1]}
                            </span>
                          </div>
                        </>
                      )
                    }
                  </p>
                </div>

                <button href="#" className="btn" onClick={() => getHostingHandler(plan)}>
                  {addToCartText[DISPLAY_LANG]}
                </button>
              </div>
            )
          })
        }
      </div>
    </div>
  );
}